/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react'
import { Box, Divider, Grid, Typography } from '@mui/material'
import ImgComplain00 from "../../../assets/Image/ImgComplain/0.jpg";
import ImgComplain03 from "../../../assets/Image/ImgComplain/3.png";
// yup
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import yupFormSchemas from 'components/Common/FormItem/yup/yupFormSchemas';
import InputFormItem from 'components/Common/ElementInForm/InputFormItem';
import { BtnAddForm, BtnHome, BtnSend } from 'components/Common/Button';
import useMediaQuery from '@mui/material/useMediaQuery';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import RadioFormItem from 'components/Common/ElementInForm/RadioFormItem';
import UploadFile from 'components/Common/ElementInForm/UploadFile/UploadFile';
import { AlertTitle, AxiosGet, AxiosPost, Extension, ResultAPI } from 'service/CommonFunction/TS_function';
import AutoCompleteSelect from 'components/Common/ElementInForm/AutoCompleteSelect';
import GoogleMapComp from 'view/Map/GoogleMapComp';
import PopUpCustom from 'components/PopupCustom/PopUpCustom';
import { SwAlert } from 'components/Common/Alert/AlertForm';
import { SnackbarCustom } from 'components/Common/Alert/Snackbars/Snackbar';
import moment from 'moment';
import { Link } from 'react-router-dom';
import InputCustomLabel from 'components/Common/ElementInForm/InputCustomLabelFormItem';
import { FnBlock_UI } from 'service/SystemFunction/SystemFunction';
import { useLocation, useNavigate } from 'react-router-dom';
import EditPurpleIcon from "../../../assets/Image/EditPurpleIcon.png";
import AOS from "aos";
import { i18n } from 'i18n';
import { currentLanguage } from 'service/CommonFunction/AxiosConfig';

const OptionTypeLocationTH = [
    { value: "1", label: "เลือกจากแผนที่" },
    { value: "0", label: "กรอกข้อมูล" },
]
const OptionTypeLocationEN = [
    { value: "1", label: "Map" },
    { value: "0", label: "Input" },
]
const i18nField = 'entities.VOCForm.fields';

const VOCForm = () => {

    const onClearFile = useRef(null);
    const formvoc = useRef<HTMLDivElement>(null);
    const location = useLocation();
    const navigate = useNavigate();

    const { BlockUI, UnBlockUI } = FnBlock_UI();
    const Layout900 = useMediaQuery('(min-width:900px)');

    const [sVOCFormID, setsVOCFormID] = useState(location?.state ? location.state["sVOCFormID"] : null)
    const [sRefVOCCode, setsRefVOCCode] = useState(null)
    const [sMessageVOC, setsMessageVOC] = useState("")


    const [IsAddTelExtention, setIsAddTelExtention] = useState(false)

    const [arrAttachment, setarrAttachment] = useState([] as any)
    const [IsCheckTel, setIsCheckTel] = useState(false)
    const [IsRequireInputTel, setIsRequireInputTel] = useState(false)
    const [IsRequireRadio, setIsRequireRadio] = useState(false)
    const [IsAddAddress, setIsAddAddress] = useState(false)

    const [OptionTypeVOC, setOptionTypeVOC] = useState([] as any);
    const [OptionTel, setOptionTel] = useState([] as any);
    const [OptionCompany, setOptionCompany] = useState([] as any);
    const [Optionlocation, setOptionlocation] = useState([] as any);

    const [IsAlertInfo, setIsAlertInfo] = useState(false)

    const [isSetMap, setIsSetMap] = useState(false)
    const [oLocationCurrent, setoLocationCurrent] = useState({
        lat: null,
        lng: null,
    })
    const [sLocation, setsLocation] = useState({
        Latitude: null,
        Longitude: null,
        Address: null,
    })

    const [DataUser, setDataUser] = useState({
        "nUserID": null,
        "sUserCode": null,
        "sFullname": null,
        "sAPIRoleName": null,
        "sUserType": null,
        "lstCompany": [],
        "lstUserBA": []
    })

    //SnankBar
    const [IsOpenSnackbar, setIsOpenSnackbar] = useState(false)
    const [sSeveritySnackbar, setsSeveritySnackbar] = useState("success")
    const [sMessageSnackbar, setsMessageSnackbar] = useState(null) as any

    const schema = yup.object().shape({
        sReferVOCCode: yupFormSchemas.string(i18n(`${i18nField}.sReference`), { required: false }),
        oVOCType: yupFormSchemas.object(i18n(`${i18nField}.sType`), { required: true }),
        sDetail: yupFormSchemas.string(i18n(`${i18nField}.sDetail`), { required: true }),
        oTel: yupFormSchemas.object(i18n(`${i18nField}.sTel`), { required: true }),
        // sInputTel: yupFormSchemas.string(i18n(`${i18nField}.sTel`), { required: IsRequireInputTel }),
        sInputTel: yupFormSchemas.string(i18n(`${i18nField}.sTel`), { required: IsRequireInputTel, max: 10, matches: /^[0-9]{0,10}$/, labelmatches: i18n(`${i18nField}.sMatchTel`) }),
        sInputTelExtension: yupFormSchemas.string(i18n(`${i18nField}.sTelExtension`), { required: IsAddTelExtention, max: 10, matches: /^[0-9]{0,10}$/, labelmatches: i18n(`${i18nField}.sMatchTel`) }),
        oCompany: yupFormSchemas.object(i18n(`${i18nField}.sCompany`), { required: true }),
        oAddress: yupFormSchemas.object(i18n(`${i18nField}.sAddress`), { required: true }),
        sTypeAddress: yupFormSchemas.string(i18n(`${i18nField}.sInputLocation`), { required: IsRequireRadio }),
        sAddress: yupFormSchemas.string(i18n(`${i18nField}.sAddress`), { required: IsAddAddress }),
    });
    const form = useForm({
        resolver: yupResolver(schema),
        mode: 'all',
        shouldFocusError: true,
        criteriaMode: "firstError"
    })

    useEffect(() => {
        AOS.init({
            duration: 1200,
        });
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth",
        });
        GetDataInitialForm();
        if (location?.state && location?.state["sVOCFormID"] && location?.state["sMode"] == "Refer") {
            GetDataVOCID();
        }
    }, [])

    useEffect(() => {
        if (sLocation.Address != null) {
            form.setValue("sAddress", sLocation.Address)
            form.clearErrors("sAddress")
        }
    }, [sLocation.Address, isSetMap])


    const GetDataVOCID = async () => {
        BlockUI();
        await AxiosGet(`VOC/VOCFormDataByID`, { sVOCFormID: sVOCFormID, "sLanguage": currentLanguage() }, (res) => {
            UnBlockUI();
            ResultAPI(res, null, async () => {
                let Result = res?.result?.data
                if (Result != null) {
                    setsRefVOCCode(Result.sVOCFormCode)
                    form.setValue("sReferVOCCode", Result.sVOCFormCode)
                    form.setValue("oVOCType", Result.objVOCType)
                    form.setValue("sDetail", Result.sDetail)
                    form.setValue("oTel", Result.objTel)
                    form.setValue("oCompany", Result.objCompany)
                    form.setValue("oAddress", Result.objAddr)
                    setIsCheckTel(Result.IsAllowContact)
                    setarrAttachment(Result.lstFormFile)
                }
            })
        })
    }

    const GetDataInitialForm = async () => {
        let nUserID = 0;
        let lstIntBA = [] as any;
        await AxiosGet("User/GetUserData", { "sLanguage": currentLanguage() }, (res) => {
            ResultAPI(res, null, () => {
                nUserID = res.result.nUserID;
                lstIntBA = (res.result.lstUserBA || []).map(m => m.nBAID);
                setDataUser({
                    "nUserID": res.result.nUserID || 0,
                    "sUserCode": res.result.sUserCode || "",
                    "sFullname": res.result.sFullname || "",
                    "sAPIRoleName": res.result.sAPIRoleName || "",
                    "sUserType": res.result.sUserType || "",
                    "lstCompany": res.result.lstCompany || [],
                    "lstUserBA": lstIntBA || [],
                });
            })
        })

        await AxiosGet(`Customer/GetDefaultDataCustomerNoPIS`, { "nUserID": nUserID }, (res) => {
            UnBlockUI();
            ResultAPI(res, null, () => {
                form.setValue("oCompany", res.oDefaultCompany ?? null)
                form.setValue("oAddress", res.oDefaultAddress ?? null)
                form.setValue("oTel", res.oDefaultTel ?? null)

            })
        });

        await AxiosGet(`BAService/GetBAType`, { "sLanguage": currentLanguage() }, (res) => {
            ResultAPI(res, null, () => {
                setOptionTypeVOC(res.result.data || [])
            })
        });

        await AxiosGet(`User/GetUserTelById`, { "sLanguage": currentLanguage(), "nUserID": nUserID, "IsAdd": true }, (res) => {
            ResultAPI(res, null, () => {
                setOptionTel(res.result.data || [])
            })
        });

        await AxiosPost(`Company/GetCustomerCompany`, { "sLanguage": currentLanguage(), "IsAdd": true }, (res) => {
            ResultAPI(res, null, () => {
                setOptionCompany(res.result.data || [])
                if (res.result.data.length == 1) {
                    form.setValue("oCompany", res.result.data[0])

                    let valueComp = res.result.data[0];
                    if (valueComp && valueComp.value) {
                        AxiosGet(`Company/GetCompanyAddress`, { "sLanguage": currentLanguage(), "nUserID": nUserID, "nCompanyID": valueComp.value, "IsAdd": true }, (res) => {
                            ResultAPI(res, null, () => {
                                setOptionlocation(res.result.data || [])
                                let chk1Option = (res.result.data || []).filter(f => f.value != "-1")
                                if (chk1Option.length === 1) {
                                    form.setValue("oAddress", chk1Option[0])
                                }
                            })
                        });
                    }
                }
            })
        });
    };

    const onHandleChangeValue = async (eventValue, sField) => {
        switch (sField) {
            case "tel":
                form.setValue("sInputTel", null)
                form.clearErrors("sInputTel")
                setIsRequireInputTel(false)
                if (eventValue && eventValue.value === "-1") {
                    setIsRequireInputTel(true)
                }
                break;
            case "company":
                setIsRequireRadio(false)
                form.setValue("oAddress", null)
                form.setValue("sAddress", null)
                if (eventValue && eventValue.value) {
                    AxiosGet(`Company/GetCompanyAddress`, { "nUserID": DataUser.nUserID, "nCompanyID": eventValue.value, "IsAdd": true }, (res) => {
                        ResultAPI(res, null, () => {
                            setOptionlocation(res.result.data || [])
                            let chk1Option = (res.result.data || []).filter(f => f.value != "-1")
                            if (chk1Option.length === 1) {
                                form.setValue("oAddress", chk1Option[0])
                            }
                        })
                    });
                }
                break;
            case "address":
                if (eventValue && eventValue.value === "-1") {
                    setIsRequireRadio(true)
                    setIsAddAddress(true)
                    form.setValue("sTypeAddress", "0")
                }
                else {
                    setIsRequireRadio(false)
                    setIsAddAddress(false)
                    setIsSetMap(false)
                }
                setIsSetMap(false)
                setoLocationCurrent({ lat: null, lng: null })
                setsLocation({
                    Latitude: null,
                    Longitude: null,
                    Address: null,
                })
                break;
            case "radioaddress":
                setIsAddAddress(true)
                // form.setValue("sAddress", null)
                form.clearErrors("sAddress")
                setIsSetMap(false)
                setoLocationCurrent({ lat: null, lng: null })
                setsLocation({
                    Latitude: null,
                    Longitude: null,
                    Address: null,
                })
                break;
        }
    }

    const SaveDataVOC = () => {
        let param = {
            "nJobTypeID": null,        //1 ข้อร้องเรียน //2 ข้อร้องขอ //3ข้อเสนอแนะ
            "sMode": "N",       //เปิดใหม่
            "cCustomerType": "E",
            "nVOCFormTypeID": 1,    //1 แจ้งปัญหา //2 สนใจผลิตภัณฑ์และบริการ //3 คำแนะนำติชม
            "nVOCTypeID": form.getValues("oVOCType") ? parseInt(form.getValues("oVOCType").value) : null,
            "nCustomerID": DataUser.nUserID,
            "nCompanyID": form.getValues("oCompany") ? parseInt(form.getValues("oCompany").value) : null,
            "sDetail": form.getValues("sDetail") ?? "",
            "nTelID": form.getValues("oTel") ? parseInt(form.getValues("oTel").value) : null,
            "sIssueDate": moment().format("DD/MM/YYYY HH:mm"),
            "IsCreateVOCByBA": false,
            "sRefVOCCode": sRefVOCCode,
            "objFormFile": arrAttachment,
            "cMoreCustomerTel": {
                "nCustomerID": DataUser.nUserID,     //user login
                "sTel": form.getValues("sInputTel") ?? null,
                "sExtension": form.getValues("sInputTelExtension") ?? null
            },
            "IsAllowContact": IsCheckTel,
            "nSelectAddrType": isSetMap === true ? 1 : 2,
            "nAddrID": form.getValues("oAddress") ? parseInt(form.getValues("oAddress").value) : null,

            "cMoreAddress": {
                "nCompanyID": form.getValues("oCompany") ? parseInt(form.getValues("oCompany").value) : null,
                "sAddress": form.getValues("sAddress") ?? null,
                "sLatitude": sLocation.Latitude ? sLocation.Latitude + "" : null,
                "sLongitude": sLocation.Longitude ? sLocation.Longitude + "" : null,
            }

        }
        let sMessage = currentLanguage() == "th" ? "คุณต้องการที่จะส่งข้อมูลใช่หรือไม่ ?" : "Do you want to send information ?";
        SwAlert.Confirm(AlertTitle.Confirm, sMessage, () => {
            BlockUI();
            AxiosPost(`VOC/SaveVOCFormData`, param, (res) => {
                UnBlockUI();
                ResultAPI(res, null, () => {
                    if (res.statusCode === 200) {
                        onClearData();
                        setsMessageVOC(res?.result?.sVOCFormCode)
                        setIsAlertInfo(true)
                        
                    }
                    else {
                        setIsOpenSnackbar(true);
                        setsMessageSnackbar(res.Message)
                        setsSeveritySnackbar("warning")
                    }
                })
            }, (res) => {
                setIsOpenSnackbar(true);
                setsMessageSnackbar(res?.response?.data?.Message)
                setsSeveritySnackbar("warning")
            }, null)
        })

    }

    const onClearData = () => {
        setIsRequireInputTel(false)
        setIsRequireRadio(false)
        setIsAddAddress(false)
        setIsAddTelExtention(false)
        form.clearErrors("sAddress")
        setIsSetMap(false)
        setoLocationCurrent({ lat: null, lng: null })
        setsLocation({
            Latitude: null,
            Longitude: null,
            Address: null,
        })
        setIsCheckTel(false)
        onClearFile.current();      //Clear Data upload file
        Object.keys(form.getValues()).forEach((key => {
            form.setValue(key, null);
            form.clearErrors(key);
        }))
    }
    const onSetDataAddress = (lan, lng, Address) => {
        form.setValue("sAddress", sLocation.Address)
        form.clearErrors("sAddress")
        setsLocation({
            Latitude: lan,
            Longitude: lng,
            Address: Address,
        })
    }

    return (
        <>
            <div style={{ position: 'relative' }}>
                <div style={{ position: 'absolute', top: !Layout900 ? '50%' : '40%', left: '10%' }}>
                    <Typography style={{ lineHeight: "1", color: '#ffffff' }}>
                        <span style={{ fontWeight: "400", display: "flex", fontSize: !Layout900 ? "1.4em" : "3em" }}>
                            {i18n(`${i18nField}.sVOC1`)}
                        </span>{" "}
                        <span style={{ fontWeight: "400", fontSize: !Layout900 ? "1.4em" : "3.2em" }}>
                            {i18n(`${i18nField}.sVOC2`)}
                        </span>
                        <Grid container spacing={2} direction="row" justifyContent="start" alignItems="center">
                            <Grid item>
                                <Link to="/Home" preventScrollReset={true}>
                                    <span style={{ fontWeight: "400", color: '#ffffff', fontSize: !Layout900 ? "0.8em" : "1em" }}>
                                        {i18n(`${i18nField}.sHomepage`)}
                                    </span>
                                </Link>
                            </Grid>
                            <Grid item>
                                <Divider orientation='vertical' style={{ height: '30px', backgroundColor: '#ffffff' }} />
                            </Grid>
                            <Grid item>
                                <span style={{ fontWeight: "400", fontSize: !Layout900 ? "0.8em" : "1em" }}>
                                    <b>{i18n(`${i18nField}.sMainPageVOC`)}</b>
                                </span>
                            </Grid>
                        </Grid>
                    </Typography>
                </div>
                <img src={ImgComplain00} alt='' style={{ width: '100%', minHeight: '250px', objectFit: 'cover' }} />
            </div>
            <div ref={formvoc}>
                <Grid container spacing={!Layout900 ? 2 : 4} direction="row" justifyContent="center" alignItems="end" style={{ marginTop: '1em' }}>
                    <Grid item xs={12}>
                        <Grid container spacing={2} direction="row" justifyContent="center" alignItems="end" style={!Layout900 ? { paddingLeft: '2em' } : {}}>
                            <Grid item xs={12} md={4} >
                                <Typography style={{ lineHeight: "0.9", color: '#202178' }}>
                                    <span style={{ fontWeight: "700", display: "flex", fontSize: !Layout900 ? "2.5em" : "3.5em" }}>
                                        GBU
                                    </span>{" "}
                                    <span style={{ fontWeight: "200", fontSize: !Layout900 ? "2.5em" : "3.5em" }}>
                                        CONTACT
                                    </span>
                                </Typography>
                            </Grid>
                            <Grid item xs={12} md={6} >
                                <Grid container spacing={2} direction="row" justifyContent="start" alignItems="center">
                                    <Grid item >
                                        <div style={{ backgroundColor: "#ffffff", borderRadius: '50%', border: '1px solid #202178', width: '3em', height: '3em', display: 'flex', padding: '20%' }}>
                                            {/* <img src={EditPurpleIcon} alt='' style={{ width: '100%' }} /> */}
                                            <Box
                                                component="div"
                                                sx={{
                                                    flexGrow: 1,
                                                    backgroundImage: `url(${EditPurpleIcon})`,
                                                    backgroundSize: "cover",
                                                    backgroundRepeat: "no-repeat",
                                                    objectFit: 'contain',
                                                    cursor: 'pointer',
                                                    // height: '43px',
                                                    width: '100%',
                                                    // margin:'7px'
                                                }}
                                            />
                                        </div>
                                    </Grid>
                                    <Grid item >
                                        <Typography style={{ lineHeight: "0.9", color: '#202178' }}>
                                            <span style={{ fontWeight: "400", display: "flex", fontSize: !Layout900 ? "1.2em" : "1.7em" }}>
                                                {i18n(`${i18nField}.sPlease`)}
                                            </span>{" "}
                                            <span style={{ fontWeight: "400", fontSize: !Layout900 ? "1.2em" : "1.7em" }}>
                                                {i18n(`${i18nField}.sCompleteInfo`)}
                                            </span>
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Divider style={{ width: '100%', marginTop: '1em' }} />
                    <Grid item xs={12}>
                        <Grid container spacing={2} direction="row" justifyContent="center" alignItems="start" style={{ marginBottom: '1em' }}>
                            {Layout900 && <Grid item xs={12} md={4} data-aos="fade-right">
                                <img src={ImgComplain03} alt='' style={{ width: '70%', borderRadius: '170px', height: '550px', objectFit: 'cover', boxShadow: '1px 1px 10px 4px rgb(0 0 0 / 20%)' }} />
                            </Grid>}
                            <Divider orientation="vertical" variant="middle" flexItem style={{ display: !Layout900 ? 'none' : 'block', margin: '24px 8px 4px', border: '0.5px solid #d4d4d4', backgroundColor: '#d4d4d4' }} />
                            <Grid item xs={12} md={!Layout900 ? 12 : 6} data-aos="fade-left">
                                <FormProvider {...form}>
                                    <Grid container spacing={2} direction="row" justifyContent="center" alignItems="center" style={{ padding: '2.5em' }}>
                                        <Grid item xs={12} >
                                            <Grid container spacing={2} direction="row" justifyContent="start" alignItems="start" >
                                                <Grid item xs={12} md={6}>
                                                    <AutoCompleteSelect
                                                        name="oVOCType"
                                                        options={OptionTypeVOC}
                                                        label={i18n(`${i18nField}.sType`)}
                                                        required={true}
                                                    />
                                                </Grid>
                                                {
                                                    sRefVOCCode != null
                                                        ?
                                                        <Grid item xs={12} md={6}>
                                                            <Grid container direction="row" justifyContent="end" alignItems="start">
                                                                <Grid item xs={12} md={6}>
                                                                    <InputFormItem
                                                                        id="sReferVOCCode"
                                                                        name="sReferVOCCode"
                                                                        label={i18n(`${i18nField}.sReference`)}
                                                                        required={false}
                                                                        fullWidth
                                                                        disabled={true}
                                                                    />
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                        : null
                                                }
                                                <Grid item xs={12} >
                                                    <InputCustomLabel
                                                        id="sDetail"
                                                        name="sDetail"
                                                        label={i18n(`${i18nField}.sDetail`)}
                                                        required={true}
                                                        multiline={true}
                                                        maxLength={1000}
                                                        rows={4}
                                                        fullWidth
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={12} md={5}>
                                                    <AutoCompleteSelect
                                                        name="oTel"
                                                        options={OptionTel}
                                                        label={i18n(`${i18nField}.sTel`)}
                                                        required={true}
                                                        onChange={(e) => { onHandleChangeValue(e, "tel");setIsAddTelExtention(false); }}
                                                    />
                                                </Grid>
                                                {
                                                    form.getValues("oTel")?.value === "-1"
                                                        ?
                                                        <>
                                                            <Grid item xs={12}>
                                                                <Grid container spacing={2} direction="row" justifyContent="start" alignItems="start">
                                                                    <Grid item xs={12} sm={12} md={5}>
                                                                        <InputFormItem
                                                                            id="sInputTel"
                                                                            name="sInputTel"
                                                                            label={i18n(`${i18nField}.sTel`)}
                                                                            required={true}
                                                                            fullWidth
                                                                            maxLength={10}
                                                                            onChange={(e)=>{
                                                                                if(e == "")
                                                                                {
                                                                                    setIsAddTelExtention(false);
                                                                                }
                                                                            }}
                                                                        />
                                                                    </Grid>
                                                                    { <Grid item xs={12} sm={12} md={'auto'}>
                                                                        <FormControlLabel
                                                                            control={
                                                                                <Checkbox
                                                                                    checked={IsAddTelExtention}
                                                                                    disabled={(!form.getValues("sInputTel"))}
                                                                                    onChange={() => {
                                                                                        setIsAddTelExtention(!IsAddTelExtention);
                                                                                        form.setValue("sInputTelExtension", null)
                                                                                    }}
                                                                                />
                                                                            }
                                                                            label={i18n(`${i18nField}.sTelExtension`)}
                                                                            labelPlacement="end"
                                                                        />
                                                                    </Grid>}
                                                                    {IsAddTelExtention &&
                                                                        <Grid item xs={12} sm={12} md={4}>
                                                                            <InputFormItem
                                                                                id="sInputTelExtension"
                                                                                name="sInputTelExtension"
                                                                                label={i18n(`${i18nField}.sTelExtension`)}
                                                                                required={true}
                                                                                maxLength={10}
                                                                                fullWidth
                                                                            />
                                                                        </Grid>
                                                                    }
                                                                </Grid>
                                                            </Grid>
                                                        </>
                                                        : null
                                                }
                                                <Grid item xs={12} style={{ marginTop: '-10px' }}>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                checked={IsCheckTel}
                                                                onChange={() => { setIsCheckTel(!IsCheckTel); }}
                                                            />
                                                        }
                                                        label={i18n(`${i18nField}.sApprove`)}
                                                        labelPlacement="end"
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={12} style={{ marginTop: '-12px' }}>
                                                    <UploadFile
                                                        id="sDocFile"
                                                        keyID={1}
                                                        sTitle={i18n(`${i18nField}.sFile`)}
                                                        IsRequired={false}
                                                        arrFile={arrAttachment || []}
                                                        setarrFile={setarrAttachment}
                                                        IsFolder={false}
                                                        IsFile={true}
                                                        IsMultiple={false}
                                                        Extension={[...Extension.PDF, ...Extension.Image, ...Extension.Word, ...Extension.Excel, ...Extension.Other]}
                                                        IsDrag={false}
                                                        nLimitFile={10}
                                                        sLimitFile={"MB"}
                                                        onClearFile={onClearFile}
                                                    />
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <AutoCompleteSelect
                                                        name="oCompany"
                                                        options={OptionCompany}
                                                        label={i18n(`${i18nField}.sCompany`)}
                                                        required={true}
                                                        onChange={(e) => { onHandleChangeValue(e, "company") }}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} >
                                                    <Grid container spacing={2} direction="row" justifyContent="start" alignItems="start" >
                                                        <Grid item xs={12} >
                                                            <AutoCompleteSelect
                                                                name="oAddress"
                                                                options={Optionlocation}
                                                                label={i18n(`${i18nField}.sAddress`)}
                                                                required={true}
                                                                onChange={(e) => { onHandleChangeValue(e, "address") }}
                                                            />
                                                        </Grid>
                                                        {
                                                            form.getValues("oAddress") && form.getValues("oAddress").value === "-1" && IsRequireRadio == true ?
                                                                <Grid item xs={12} style={{ marginTop: '-10px' }}>
                                                                    <RadioFormItem
                                                                        name="sTypeAddress"
                                                                        label={i18n(`${i18nField}.sInputLocation`)}
                                                                        required={true}
                                                                        options={currentLanguage() == "th" ? OptionTypeLocationTH : OptionTypeLocationEN}
                                                                        value={form.getValues("sTypeAddress")}
                                                                        row={true}
                                                                        IsNewLine={false}
                                                                        onChange={(e) => { onHandleChangeValue(e, "radioaddress"); }}
                                                                    />
                                                                </Grid>
                                                                :
                                                                null
                                                        }
                                                    </Grid>
                                                </Grid>
                                                {
                                                    form.getValues("sTypeAddress") && IsRequireRadio == true ?
                                                        <Grid item xs={12} >
                                                            <InputFormItem
                                                                id="sAddress"
                                                                name="sAddress"
                                                                label={i18n(`${i18nField}.sAddress`)}
                                                                required={true}
                                                                fullWidth
                                                            />
                                                        </Grid>
                                                        : null
                                                }
                                                {
                                                    form.getValues("sTypeAddress") && form.getValues("sTypeAddress") === "1" && IsRequireRadio == true ?
                                                        <Grid item xs={12} >

                                                            <GoogleMapComp
                                                                MapHeight={"600px"}
                                                                oLocationCurrent={oLocationCurrent}
                                                                setoLocationCurrent={setoLocationCurrent}
                                                                onSetDataAddress={onSetDataAddress}
                                                            />
                                                        </Grid>
                                                        : null
                                                }
                                            </Grid>
                                        </Grid>
                                        <Grid item >
                                            <BtnSend txt={i18n(`${i18nField}.sSendData`)} onClick={form.handleSubmit(() => { SaveDataVOC() })} />
                                        </Grid>
                                    </Grid>
                                </FormProvider>
                            </Grid>
                        </Grid>


                    </Grid>
                </Grid>
            </div>
            <SnackbarCustom
                IsOpen={IsOpenSnackbar}
                Severity={sSeveritySnackbar}
                OnClose={() => { setIsOpenSnackbar(false) }}
                Message={sMessageSnackbar}
            />
            <PopUpCustom
                setIsOpen={setIsAlertInfo}
                IsOpen={IsAlertInfo}
                sMaxWidth={'sm'}
                JsxDialogHeader={
                    <>
                        <Typography>{i18n(`${i18nField}.sReportResults`)}</Typography>
                    </>
                }
                JsxDialogContent={
                    currentLanguage() == "th" ?
                        <>
                            <Typography>เราได้รับเรื่องของคุณเรียบร้อยแล้วและเจ้าหน้าที่จะติดต่อกลับภายใน 24 ชั่วโมง</Typography>
                            <Typography>ขอบคุณที่ใช้บริการ</Typography>
                            <Typography>เลขที่ใบแจ้ง : {sMessageVOC}</Typography>
                        </>
                        :
                        <>
                            <Typography>We have received your case and our staff will contact you within 24 hours.</Typography>
                            <Typography>Thank you for using the service.</Typography>
                            <Typography>Report Number : {sMessageVOC}</Typography>
                        </>
                }
                JsxDialogAction={
                    <>
                        <Grid container spacing={1} direction="row" justifyContent="end" alignItems="center">
                            <Grid item >
                                <BtnAddForm
                                    txt={currentLanguage() == "th" ? "แจ้งปัญหาเพิ่มเติม" : "Add more uVoice"}
                                    onClick={() => {
                                        setsRefVOCCode(null)
                                        GetDataInitialForm()
                                        if (formvoc && formvoc.current) {
                                            window.scrollTo({ behavior: 'smooth', top: formvoc.current.offsetTop - 64 })
                                        }
                                        setIsAlertInfo(false);
                                    }}
                                />
                            </Grid>
                            <Grid item >
                                <BtnHome
                                    txt={currentLanguage() == "th" ? "กลับสู่หน้าหลัก" : "Home page"}
                                    onClick={() => { navigate("/Home") }} />
                            </Grid>
                        </Grid>
                    </>
                }
            />
        </>

    )
}

export default VOCForm